import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=1613fa43&scoped=true&"
import script from "./Currencies.vue?vue&type=script&lang=js&"
export * from "./Currencies.vue?vue&type=script&lang=js&"
import style0 from "./Currencies.vue?vue&type=style&index=0&id=1613fa43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1613fa43",
  null
  
)

export default component.exports